import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import QuotationsList from './pages/QuotationsList';
import CreateQuotation from './pages/CreateQuotation';
import EditQuotation from './pages/EditQuotation';
import ViewQuotation from './pages/ViewQuotation';
import PurchaseOrdersList from './pages/PurchaseOrdersList';
import CreatePurchaseOrder from './pages/CreatePurchaseOrder';
import EditPurchaseOrder from './pages/EditPurchaseOrder';
import ViewPurchaseOrder from './pages/ViewPurchaseOrder';
import ProformaInvoicesList from './pages/ProformaInvoicesList';
import CreateProformaInvoice from './pages/CreateProformaInvoice';
import EditProformaInvoice from './pages/EditProformaInvoice';
import ViewProformaInvoice from './pages/ViewProformaInvoice';
import AdminPanel from './pages/AdminPanel';
import TendersPanel from './pages/TendersPanel';
import TenderAnalytics from './pages/TenderAnalytics';
import LoginPage from './pages/LoginPage';
import ControlPanel from './pages/ControlPanel';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-stone-400 text-sm">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoginRoute() {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-stone-400 text-sm">Loading...</div>;
  if (user) return <Navigate to="/" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/control-panel" element={<ControlPanel />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<QuotationsList />} />
                  <Route path="/create-quotation" element={<CreateQuotation />} />
                  <Route path="/edit-quotation/:id" element={<EditQuotation />} />
                  <Route path="/quotation/:id" element={<ViewQuotation />} />
                  <Route path="/purchase-orders" element={<PurchaseOrdersList />} />
                  <Route path="/create-purchase-order" element={<CreatePurchaseOrder />} />
                  <Route path="/edit-purchase-order/:id" element={<EditPurchaseOrder />} />
                  <Route path="/purchase-order/:id" element={<ViewPurchaseOrder />} />
                  <Route path="/proforma-invoices" element={<ProformaInvoicesList />} />
                  <Route path="/create-proforma-invoice" element={<CreateProformaInvoice />} />
                  <Route path="/edit-proforma-invoice/:id" element={<EditProformaInvoice />} />
                  <Route path="/proforma-invoice/:id" element={<ViewProformaInvoice />} />
                  <Route path="/admin" element={<AdminPanel />} />
                  <Route path="/tenders" element={<TendersPanel />} />
                  <Route path="/tender-analytics" element={<TenderAnalytics />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
